<template>
  <div data-test="form-instructional-method">
    <DynamicForm
      :editable="editable"
      :formId="formId"
    />
    <DynamicForm
      :editable="editable"
      :formId="customFormId"
    />
    <AppButton
      v-if="!disabled"
      variant="danger"
      @click="$emit('delete')"
    >
      <AppIcon name="delete" />
    </AppButton>
  </div>
</template>

<script>
import _chunk from 'lodash/chunk'
import { computed, ref, toRefs } from '@vue/composition-api'
import useDynamicForm from '@/components/DynamicForms/useDynamicForm'
import useDataSources from '@/components/DynamicForms/useDataSources'
import useFeatureFlags from '@/components/composables/useFeatureFlags'
import { INTEGRATION_ETHOS_INSTRUCTIONAL_METHOD_ID_KEY } from '@shared/constants/featureFlags'
export default {
  components: {
    DynamicForm: () => import('@/components/DynamicForms/DynamicForm'),
  },
  props: {
    value: {
      required: true,
      type: Object,
    },
    index: {
      type: Number,
      required: true,
    },
    formValue: {
      type: Object,
      default: () => ({}),
    },
    config: {
      required: true,
      type: Object,
    },
    editable: {
      default: true,
      type: Boolean,
    },
    disabled: {
      default: false,
      type: Boolean,
    },
    iteration: {
      type: Number,
      default: 0,
    },
    nestedMode: {
      type: Boolean,
      default: true,
    },
  },
  setup (props, { root }) {
    const { integrationKeyIMByID } = useFeatureFlags({
      integrationKeyIMByID: INTEGRATION_ETHOS_INSTRUCTIONAL_METHOD_ID_KEY,
    })
    const basicQuestions = integrationKeyIMByID ? [ 'id' ] : [ 'name', 'code' ]

    const { config, formValue, value } = toRefs(props)
    const path = computed(() => `instructionalMethods.${props.index}`)
    const { addLocalSourceData } = useDataSources({ overrideLocalSources: true })
    addLocalSourceData('record', value)

    const questions = computed(() => Object.entries(config.value?.fields || {})
      .map(([ key, value ]) => ({
        ...value,
        ...(key === 'code' && !integrationKeyIMByID && { required: true }),
        ...(key === 'id' && integrationKeyIMByID && { required: true }),
      })))
    const customQuestionsIds = computed(() => questions.value.map(v => v.questionId).filter(key => !basicQuestions.includes(key)))
    const customTemplateLayout = _chunk(customQuestionsIds.value, 2)

    function generateTemplateRow (rowKeys, index) {
      return {
        type: 'row',
        id: `method_row_${index}`,
        children: rowKeys.map(fieldKey => ({ type: 'question', id: fieldKey })),
      }
    }
    const basicTemplate = ref([ basicQuestions ].map(generateTemplateRow))
    const customTemplate = ref(customTemplateLayout.map(generateTemplateRow))
    const { formId } = useDynamicForm({
      questions,
      template: basicTemplate,
      formValue: props.nestedMode ? formValue : value,
      path: props.nestedMode ? path : undefined,
    })
    const { formId: customFormId } = useDynamicForm({
      questions,
      template: customTemplate,
      formValue: props.nestedMode ? formValue : value,
      path: props.nestedMode ? ref(`${path.value}.customFields`) : 'customFields',
    })

    return {
      formId,
      customFormId,
    }
  },
}
</script>
